////////////////////////////////////////////////////////////////////////////////
//
// Store site module
//
////////////////////////////////////////////////////////////////////////////////

import {Mutation} from "@/store/mutations";
import {Action} from "@/store/actions";
import ApiService from "@/services/api.service";

const state = {
    sites: [],
    isLoading: false,
}

////////////////////////////////////////////////////////////////////////////////

const getters = {
    siteByName: state => (name) => state.sites.find(site => site.name === name)
};

////////////////////////////////////////////////////////////////////////////////

const actions = {
    async [Action.site.load](context) {
        try {
            context.commit('setLoading', true)
            const result = await ApiService.site.all()
            if (Array.isArray(result.data.data.data)) {
                context.commit(Mutation.site.set, result.data.data.data)
            } else {
                context.commit(Mutation.site.set, [])
            }
            context.commit('setLoading', false)
        } catch (error) {
            context.commit(Mutation.notifyApiError, error)
            context.commit('setLoading', false)
            return Promise.reject(error)
        }
    },

    async [Action.site.delete](context, site) {
        try {
            await ApiService.site.del(site.name)
            await this.dispatch(Action.site.load)
            context.commit(Mutation.notify, {message: "Account deleted", type: 'success'})
        } catch (error) {
            context.commit(Mutation.notifyApiError, error)
            return Promise.reject(error)
        }
    },

    async [Action.site.add](context, document) {
        try {
            const result = await ApiService.site.add({document})
            context.commit(Mutation.notify, {message: result.data.data.status, type: 'success'})
        } catch (error) {
            context.commit(Mutation.notifyApiError, error)
            return Promise.reject(error)
        }
    },

    async [Action.site.save](context, data) {
        try {
            await ApiService.site.save(data.name, data.data)
            context.commit(Mutation.notify, {message: "Site saved", type: 'success'})
        } catch (error) {
            context.commit(Mutation.notifyApiError, error)
            return Promise.reject(error)
        }
    },
      async [Action.site.uploadSiteFile](context, formData) {
        try {
            const result = await ApiService.site.uploadSiteFile(formData);
            return result;
        } catch (error) {
             if (error.response?.data?.message?.includes('device_path')) {
        context.commit(Mutation.setError, 'Invalid device path format');
      } else {
        context.commit(Mutation.notifyApiError, error);
      }
            return Promise.reject(error);
        }
    },
    // === ICONS ===
async [Action.site.uploadSiteIcon](context, formData) {
    try {
        const result = await ApiService.site.uploadSiteIcon(formData);
        return result;
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},

async [Action.site.listSiteIcons](context, siteId) {
    try {
        const response = await ApiService.site.listSiteIcons(siteId);
        return response.data;
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},

async [Action.site.deleteSiteIcon](context, iconId) {
    try {
        const response = await ApiService.site.deleteSiteIcon(iconId);
        return response.data;
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},

async [Action.site.deleteAllSiteIcons](context, siteId) {
    try {
        const response = await ApiService.site.deleteAllSiteIcons(siteId);
        return response.data;
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},
    async [Action.site.uploadSiteFirmware](context, formData) {
    try {
      const result = await ApiService.site.uploadSiteFirmware(formData);
      return result;
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
   async [Action.site.listSiteFiles](context, siteId) {
        try {
            const response = await ApiService.site.listSiteFiles(siteId);
            return response.data;
        } catch (error) {
            context.commit(Mutation.notifyApiError, error);
            return Promise.reject(error);
        }
    },
    
    async [Action.site.deleteSiteFile](context, fileId) {
        try {
            const response = await ApiService.site.deleteSiteFile(fileId);
            return response.data;
        } catch (error) {
            context.commit(Mutation.notifyApiError, error);
            return Promise.reject(error);
        }
    },
     async [Action.site.listSiteFirmware](context, siteId) {
    try {
      const response = await ApiService.site.listSiteFirmware(siteId);
      return response.data;
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  
  async [Action.site.deleteSiteFirmware](context, firmwareId) {
    try {
      const response = await ApiService.site.deleteSiteFirmware(firmwareId);
      return response.data;
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  // Add these to your store actions
async [Action.site.deleteAllSiteFiles](context, siteId) {
  try {
    const response = await ApiService.site.deleteAllSiteFiles(siteId);
    return response.data;
  } catch (error) {
    context.commit(Mutation.notifyApiError, error);
    return Promise.reject(error);
  }
},

async [Action.site.deleteAllSiteFirmware](context, { siteId, deviceType }) {
  try {
    const response = await ApiService.site.deleteAllSiteFirmware(siteId, deviceType);
    return response.data;
  } catch (error) {
    context.commit(Mutation.notifyApiError, error);
    return Promise.reject(error);
  }
}
}

////////////////////////////////////////////////////////////////////////////////

const mutations = {
    [Mutation.site.set](state, sites) {
        state.sites = sites;
    },
    setLoading(state, loading) {
      state.isLoading = loading
    }
}

////////////////////////////////////////////////////////////////////////////////

const app = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
}
export default app